module.exports = __webpack_public_path__ + "static/media/degradado.67f4ef8d.png";